// src/services/ConsultantService.js
import { base_url } from "../utils/constante";
import { getTokenEspace, ouvrirEspace, getCreateurActif } from "../utils/agirPour";

function headers(json = false, admin = false) {
    const token = admin
        ? (localStorage.getItem("token_admin") || sessionStorage.getItem("token_admin"))
        : getTokenEspace();
    const c = getCreateurActif();
    return {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        ...(json ? { "Content-Type": "application/json" } : {}),
        // Créateur choisi → envoyé explicitement (en plus de l'intercepteur)
        ...(!admin && c ? { "X-Agir-Pour": String(c.id) } : {}),
    };
}

async function appel(url, options = {}) {
    const admin = url.startsWith("admin/");
    const c = getCreateurActif();
    // Créateur choisi aussi dans l'URL (?agir_pour=ID)
    if (!admin && c && !/[?&]agir_pour=/.test(url)) url += `${url.includes("?") ? "&" : "?"}agir_pour=${c.id}`;
    const res = await fetch(`${base_url}${url}`, { headers: headers(!!options.body, admin), ...options });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || "Erreur serveur");
    return data;
}

// ══════════════ CONNEXION CONSULTANT (endpoint séparé) ══════════════

export async function loginConsultant(email, password) {
    const res = await fetch(`${base_url}login/consultant`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ email, password }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) throw new Error(data.message || "Connexion impossible");

    // Clés SÉPARÉES de l'espace créateur ("token")
    localStorage.setItem("token_consultant", data.token);
    localStorage.setItem("consultant_nom", data.user?.nomComplet || "");
    ouvrirEspace("consultant");
    return data;
}

// ══════════════ CONSULTANT ══════════════

export const getMesCreateurs = (q = "") =>
    appel(`consultant/createurs${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((d) => d.createurs || []);

export const envoyerHeartbeat = (createurId) =>
    appel("consultant/heartbeat", { method: "POST", body: JSON.stringify({ createur_id: createurId }) });

export const getMonActivite = () => appel("consultant/mon-activite");

// Liste des événements du créateur actif (route créateur existante,
// l'en-tête X-Agir-Pour est ajouté automatiquement)
// filtre : "tous" | "avenir" | "passes"  → fait côté SERVEUR (10 par page)
export async function getEvenementsCreateurActif(page = 1, search = "", filtre = "tous") {
    const today = new Date().toISOString().split("T")[0];
    const body = { page, sort: "date", order: filtre === "avenir" ? "asc" : "desc" };
    if (search) body.search = search;
    if (filtre === "avenir") body.start_date = today;
    if (filtre === "passes") body.end_date = today;
    const d = await appel("createur/myEvents", { method: "POST", body: JSON.stringify(body) });
    const events = d.events || [];
    const p = d.pagination || {};
    // myEvents renvoie title / date / img / is_active → on normalise
    const norm = (ev) => ({
        ...ev,
        nomEven: ev.nomEven ?? ev.title,
        sousNomEven: ev.sousNomEven ?? ev.subtitle,
        dateEven: ev.dateEven ?? ev.date,
        imgEven: ev.imgEven ?? ev.img,
        isActive: ev.isActive ?? (ev.is_active === false || ev.is_active === 0 ? 0 : 1),
    });
    return {
        events: Array.isArray(events) ? events.map(norm) : [],
        pagination: {
            current_page: p.current_page || page,
            last_page: p.last_page || 1,
            total: p.total ?? (Array.isArray(events) ? events.length : 0),
        },
    };
}

// ══════════════ ADMIN ══════════════

const qs = (params) =>
    new URLSearchParams(Object.entries(params).filter(([, v]) => v !== "" && v != null)).toString();

export const adminGetConsultants = (filtres = {}) => appel(`admin/consultants?${qs(filtres)}`);

export const adminCreerConsultant = (payload) =>
    appel("admin/consultants", { method: "POST", body: JSON.stringify(payload) });

export const adminResetPassword = (id) => appel(`admin/consultants/${id}/password`, { method: "POST" });

export const adminSupprimerConsultant = (id) => appel(`admin/consultants/${id}`, { method: "DELETE" });

export const adminAttribuerCreateurs = (id, createurIds) =>
    appel(`admin/consultants/${id}/createurs`, { method: "PUT", body: JSON.stringify({ createur_ids: createurIds }) });

export const adminRechercheCreateurs = (q) =>
    appel(`admin/createurs/recherche?${qs({ q })}`).then((d) => d.createurs || []);

export const adminJournal = (filtres = {}) => appel(`admin/consultants/journal?${qs(filtres)}`);

export const adminTemps = (id, filtres = {}) => appel(`admin/consultants/${id}/temps?${qs(filtres)}`);

export async function adminExportCsv(filtres = {}) {
    const res = await fetch(`${base_url}admin/consultants/export?${qs(filtres)}`, { headers: headers(false, true) });
    if (!res.ok) throw new Error("Export impossible");
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `journal-consultants-${filtres.du || ""}_${filtres.au || ""}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
}

// ══════════════ HELPERS ══════════════

export function formatDuree(secondes) {
    const s = Number(secondes) || 0;
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    if (h === 0) return `${m} min`;
    return `${h} h ${String(m).padStart(2, "0")}`;
}